import React from 'react';
import { Link } from 'react-router-dom';

import CreatedMasterLeague from './Created';
import MasterLeaguesByStatus from "./MasterLeagueByStatus";
import MasterLeagueRestart from "./MasterLeagueRestart";

export default () => (
    <div id="statistics-leagues">
        <header className="content-header">
            <h1>
                Statistics
                <small>MasterLeague</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-bar-chart"/> Statistics</li>
                <li className="text-bold"><Link to="/statistics/masterLeague">Master League</Link></li>
            </ol>
        </header>
        <section className="content">
            <div className="row">
                <div className="col-lg-6">
                    <CreatedMasterLeague />
                </div>
                <div className="col-lg-6">
                    <MasterLeagueRestart />
                </div>
                <div className="col-lg-6">
                    <MasterLeaguesByStatus />
                </div>
            </div>
        </section>
    </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/MasterLeague/index.js